module.exports = __webpack_public_path__ + "img/13200.86a188c9.jpg";